module.exports = __webpack_public_path__ + "7a97b87c2cac8ca042b4f6b6b58cdec8.pdf";